import React from 'react'
import PropTypes from 'prop-types'
import { GlobalContext, UserContext } from 'components/context'
import { ActionButton } from 'components/Buttons'
import { StandardErrorPage, StandardPage } from 'components/DefaultPages'
import { useLogEvent } from 'components/hooks'
import { currentActiveTypeFromKeys } from 'helpers'

const Success = ({ success, t }) => {
  return (
    <StandardPage
      headerI18nKey={'pages.lost_chip.success.title'}
      type={'success'}
    >
      <p
        dangerouslySetInnerHTML={{
          __html: t('pages.lost_chip.success.info', success),
        }}
      />
    </StandardPage>
  )
}

Success.propTypes = {
  success: PropTypes.object,
  t: PropTypes.func,
}

const Index = ({ membership }) => {
  const { t } = React.useContext(GlobalContext)
  const { refreshMember, apiDelete } = React.useContext(UserContext)
  const [success, setSuccess] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const { logEvent } = React.useContext(UserContext)

  useLogEvent('view_lost_chip')

  const goBack = () => {
    setError(null)
    setSuccess(null)
  }

  const rfid = currentActiveTypeFromKeys(membership.keys, 'rfid')
  const rfidCode = rfid?.code
  const cost = t('pages.membership.access.rfid.activate.lost_info.replacement_cost', { fee: membership.access_chip.fee / 100 })

  const onClick = () => {
    if (isSubmitting) return

    setIsSubmitting(true)

    refreshMember()
      .then((updatedMembership) => {
        if (updatedMembership.keys.some((key) => key.code === rfidCode)) {
          apiDelete('rfids', null, { code: rfidCode })
            .then(res => {
              setSuccess(res)
              logEvent('reported_lost_chip')
            })
            .catch(err => {
              setError(err)
            })
        } else {
          setError({ message: 'Key not assigned', type: 'header' })
        }
      })
      .finally(() => setIsSubmitting(false))
  }

  if (error) return <StandardErrorPage error={error} goBack={goBack}/>
  if (success) return <Success success={success} t={t} />

  // TODO: Fee should be looked up and provided as arg to the translation.
  return (
    <div>
      <h1>{ t('pages.lost_chip.title') }</h1>
      <p
        dangerouslySetInnerHTML={{
          __html: t('pages.lost_chip.info', { fee: '0', cost }),
        }}
      />
      <ActionButton onClick={onClick} disabled={isSubmitting}>
        { t('pages.lost_chip.button') }
      </ActionButton>
    </div>
  )
}

Index.propTypes = {
  membership: PropTypes.object.isRequired,
}

export default Index
